import 'shared/ad_utils';

window.getVideoAdSessionValues = function (videoId) {
    var videoAdSessionValues = '';
    var cbsAdvVal = jQuery.cookie('CBS_ADV_VAL');
    var cbsAdvSubsesVal = jQuery.cookie('CBS_ADV_SUBSES_VAL');

    if (cbsAdvVal != null && cbsAdvVal != '') videoAdSessionValues = 'session=' + cbsAdvVal;
    if (cbsAdvSubsesVal != null && cbsAdvSubsesVal != '')
        videoAdSessionValues = videoAdSessionValues + ';subses=' + cbsAdvSubsesVal;
    if (typeof adId !== 'undefined' && adId != '')
        videoAdSessionValues = videoAdSessionValues + ';test=1;adId=' + adId;

    var firstpg =
        document.cookie.indexOf('first_page_today') == -1 ||
        (typeof firstpgvar != 'undefined' && firstpgvar == 1)
            ? '1'
            : '0';
    if (typeof firstpg !== 'undefined' && firstpg != '')
        videoAdSessionValues = videoAdSessionValues + ';firstpg=' + firstpg;

    var cbs_u = jQuery.cookie('CBS_U');
    if (cbs_u != null) {
        cbs_u = cbs_u.replace(/"/g, '');
        var result = {};
        cbs_u.split('|').forEach(function (x) {
            var arr = x.split(':');
            arr[1] && (result[arr[0]] = arr[1]);
        });
        if (result.ge != 'null' && result.ge != '')
            videoAdSessionValues = videoAdSessionValues + ';ge=' + result.ge;
        if (result.gr != 'null' && result.gr != '')
            videoAdSessionValues = videoAdSessionValues + ';gr=' + result.gr;
    }

    //if(location.search != "") var ttag = location.search.getValueByKey("ttag");
    //if ((typeof(ttag) !== 'undefined') && (ttag != '')) videoAdSessionValues = videoAdSessionValues + ";ttag=" + ttag;

    if (location.search != '') var ftag = location.search.getValueByKey('ftag');
    if (typeof ftag !== 'undefined' && ftag != '')
        videoAdSessionValues = videoAdSessionValues + ';ftag=' + ftag;

    if (location.search != '') {
        if (location.search.indexOf('adTargeting_') != -1) {
            var adTargetingParamKey = getBaseParam('adTargeting_')[0];
            adTargetingParamKey = adTargetingParamKey.replace('adTargeting_', '');
            var adTargetingParamValue = getBaseParam('adTargeting_')[1];
            videoAdSessionValues =
                videoAdSessionValues + ';' + adTargetingParamKey + '=' + adTargetingParamValue;
        }
    }

    return videoAdSessionValues;
};

window.getBaseParam = function (sname) {
    var params = location.search.substr(location.search.indexOf('?') + 1);
    var sarr = new Array();
    params = params.split('&');
    for (var i = 0; i < params.length; i++) {
        var temp = params[i].split('=');
        if (temp[0].indexOf(sname) != -1) {
            sarr[0] = temp[0];
            sarr[1] = temp[1];
        }
    }
    return sarr;
};

window.String.prototype.getValueByKey = function (k) {
    var p = new RegExp('\\b' + k + '\\b', 'gi');
    return this.search(p) != -1
        ? decodeURIComponent(
              this.substr(this.search(p) + k.length + 1).substr(
                  0,
                  this.substr(this.search(p) + k.length + 1).search(/(&|;|$)/),
              ),
          )
        : '';
};
